// import { Grid } from "@material-ui/core";
import { Button, Grid, ThemeProvider, Select, Box, MenuItem,Radio, InputLabel, FormControl, Card, Typography } from "@mui/material";
import React from "react";
// import ContextualTranslationEditing from "./ContextualTranslationEditing";
// import SemanticTextualSimilarityChart from "./SemanticTextualSimilarityChart";
import ContextualSentenceVerificationChart from "./ContextualSentenceVerificationChart";
import TaskAnalyticsDataAPI from "../../../../../redux/actions/api/Progress/TaskAnalytics";
import SingleSpeakerAudioTranscriptionEditing from "./SingleSpeakerAudioTranscriptionEditing";
// import AudioSegmentation from "./AudioSegmentation";
// import AudioTranscription from "./AudioTranscription";
import APITransport from "../../../../../redux/actions/apitransport/apitransport";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Spinner from "../../../component/common/Spinner";
import LightTooltip from '../../../component/common/Tooltip';
import { translate } from "../../../../../config/localisation";
import InfoIcon from '@mui/icons-material/Info';
import AudioTaskAnalyticsChart from "./AudioTaskAnalyticsChart";
import TaskCountAnalyticsChart from "./TaskCountAnalyticsChart";
import { MenuProps } from "../../../../../utils/utils";
import CustomButton from "../../../component/common/Button";


// Analytics responses are keyed by internal names ("MonolingualTranslation");
// the type lists in this file use display names ("Monolingual Translation").
const isOfType = (types, projectType) =>
  types.some((t) => t.replace(/\s+/g, "") === String(projectType || "").replace(/\s+/g, ""));

const TaskAnalytics = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [projectTypes, setProjectTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("Contextual Translation Editing");
  const ProjectTypes = useSelector((state) => state.getProjectDomains.data);
  // Rendered both with and without a loggedInUserData prop; fall back to the store.
  const storeUser = useSelector((state) => state.fetchLoggedInUserData.data);
  const orgId = (props?.loggedInUserData || storeUser)?.organization?.id;
  const apiError = useSelector((state) => state.apiStatus.error);
  const taskAnalyticsData = useSelector(
    (state) => state.getTaskAnalyticsData.data
  );

  const getTaskAnalyticsdata = () => {
     setLoading(true)
    const userObj = new TaskAnalyticsDataAPI(orgId, selectedType);
    dispatch(APITransport(userObj));
  };

  const audioProjectTypes = [
    "Audio Transcription",
    "Audio Segmentation",
    "Audio Transcription Editing",
    "Acoustic Normalised Transcription Editing",
  ];
  const translationProjectTypes = [
    "Monolingual Translation",
    "Translation Editing",
    "Semantic TextualSimilarity_Scale5",
    "Contextual Translation Editing",
    "Sentence Splitting",
    "Contextual Sentence Verification",
    "Contextual Sentence Verification And Domain Classification",
  ];
  const conversationProjectTypes = [
    "Conversation Translation",
    "Conversation Translation Editing",
    "Conversation Verification",
  ];
  const ocrProjectTypes = ["OCR Transcription Editing"];

  useEffect(() => {
    let types=[...audioProjectTypes,...translationProjectTypes,...conversationProjectTypes,...ocrProjectTypes,'AllTypes']
    setProjectTypes(types);
  }, []);

  useEffect(() => {
    if (orgId) getTaskAnalyticsdata();
  }, [orgId]);

  useEffect(() => {
    if (apiError) setLoading(false);
  }, [apiError]);

  const handleSubmit = async () => {
    getTaskAnalyticsdata();
  }

  useEffect(() => {
    if(taskAnalyticsData.length > 0){
      setLoading(false);
    }
  }, [taskAnalyticsData]);

  return (
    <>
      {/* {console.log(taskAnalyticsData[0])} */}
      <Grid container columnSpacing={3} rowSpacing={2}  mb={1} gap={3}>
        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label" sx={{ fontSize: "16px" }}>
              Project Type {" "}
              {
                <LightTooltip
                  arrow
                  placement="top"
                  title={translate("tooltip.ProjectType")}>
                  <InfoIcon
                    fontSize="medium"
                  />
                </LightTooltip>
              }
            </InputLabel>

            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedType}
              label="Project Type"
              sx={{padding:"1px"}}
              onChange={(e) => setSelectedType(e.target.value)}
              MenuProps={MenuProps}
            >
              {projectTypes.map((type, index) => (
                <MenuItem value={type} key={index}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <CustomButton label="Submit" sx={{ width:"120px", mt: 3 }} onClick={handleSubmit}
              disabled={loading} />

      </Grid>
      {loading && <Spinner />}
      {taskAnalyticsData.length ?
        taskAnalyticsData.map((analyticsData,_index)=>{
          if (analyticsData.length && isOfType(audioProjectTypes, analyticsData[0].projectType)){
            return (<Grid key={_index} style={{marginTop:"15px"}}>
            <AudioTaskAnalyticsChart analyticsData={analyticsData}/>
          </Grid>)}
          if(analyticsData.length && 
            (isOfType(translationProjectTypes, analyticsData[0].projectType) ||
              isOfType(conversationProjectTypes, analyticsData[0].projectType)
              )
            ){
            return <Grid key={_index} style={{marginTop:"15px"}}>
            <TaskCountAnalyticsChart analyticsData={analyticsData}/>
          </Grid>
          }
        })
      :''}
    </>
  );
};

export default TaskAnalytics;
